import RightChevron from "react-icons/lib/fa/chevron-right"
import styled from "styled-components"

export default styled(RightChevron)`
  transform: rotate(0deg);
`
